import templateOnly from '@ember/component/template-only';
import { precompileTemplate } from '@ember/template-compilation';
import { setComponentTemplate } from '@ember/component';

var TEMPLATE = precompileTemplate("<span class=\"ql-formats\" ...attributes>\n  {{yield}}\n</span>\n");

var group = setComponentTemplate(TEMPLATE, templateOnly());

export { group as default };
//# sourceMappingURL=group.js.map
